/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LinguisticQualityReviewPhase {
    AI_REVIEW = 'AI_REVIEW',
}
